// extracted by mini-css-extract-plugin
export default {"work_type_section":"ourwork_work_type_section__yA2zI","work_card_contain":"ourwork_work_card_contain__BS9zM"};